const ACTION = {
    UPDATE_MAIL_PAYMENT_ORDER: 'UPDATE_MAIL_PAYMENT_ORDER',
    UPDATE_MAIL_PAYMENT_ORDER_ERROR_TEXT: 'UPDATE_MAIL_PAYMENT_ORDER_ERROR_TEXT',
    UPDATE_MAIL_PAYMENT_ORDER_ERROR_TEXT_BY_INDEX: 'UPDATE_MAIL_PAYMENT_ORDER_ERROR_TEXT_BY_INDEX'
}

export default ACTION;